import template from './vue-radio-strip.vue.html';

export const VueRadioStripComponent = {
	template,
	props: ['value', 'options'],
	data() {
		return {
			draggingEnabled : false,
			dragging        : false,
			dragOriginX     : 0,
			offsetX         : 0,
			totalWidth      : 0
		};
	},
	mounted() { // silly silly...
		window.addEventListener( 'fix-switches', this.setTotalWidth);
		window.addEventListener( 'resize', this.setTotalWidth);
		this.setTotalWidth()
	},
	
	beforeDestroy() {
		window.removeEventListener('resize', this.setTotalWidth);
		window.removeEventListener('fix-switches', this.setTotalWidth);
	},
	
	
	computed: {
		buttonWidth : function() {
			return this.totalWidth / this.options.length;
		},
		
		$slider: function() {
			return $( this.$refs.slider );
		},
		
		selectedIndex: function () {
			if ( !this.value && this.value !== 0) { // 0 could be a choice
				return -1;
			}
			return _.findIndex( this.options, v => v.value === this.value );
		},
	},
	methods : {
		setTotalWidth: function () {
			this.totalWidth = this.$refs.inner.clientWidth;
		},
		
		limitedOffset: function ( offset ) {
			let minOffset  = - this.selectedIndex * this.buttonWidth;
			let maxOffset = (this.options.length - 1 - this.selectedIndex) * this.buttonWidth;
			return Math.max( Math.min( maxOffset, offset ), minOffset );
		},
		// Drag support
		touchStart : function ( evt ) {
			if( !this.draggingEnabled ) { return; }
			this.dragStart = performance.now();
			this.dragging    = true;
			this.dragOriginX = evt.changedTouches[ 0 ].clientX;
			window.addEventListener( 'touchend', this.touchEnd, {passive: true} );
		},
		touchMove : function ( evt ) {
			if( !this.draggingEnabled ) { return; }
			this.offsetX = this.limitedOffset( evt.changedTouches[ 0 ].clientX - this.dragOriginX );
		},
		touchEnd: function () {
			if( !this.draggingEnabled ) { return; }
			let dragDuration = performance.now() - this.dragStart;
			
			window.removeEventListener( 'touchend', this.touchEnd, { passive: true } );
			this.dragging = false;
			
			if ( dragDuration < 200 ) { // Flick
				if ( this.offsetX < 0 ) {
					this.$emit('input', this.options[ 0 ].value);
				} else if ( this.offsetX > 0 ) {
					this.$emit('input', this.options[ this.options.length - 1 ].value);
				}
			} else {
				let buttonWidth     = ( this.$refs.inner.clientWidth / this.options.length );
				let offsetOptions   = Math.round( this.offsetX / buttonWidth );
				let newIndex        = this.selectedIndex + offsetOptions;
				this.$emit('input', this.options[ newIndex ].value);
			}
			
			this.offsetX = 0;
		},
		onClickedOption: function( option ) {
			this.$emit('input', option);
		},

		changeOption: function( option ) {
			console.log('changeOption: Try to avoid using this function. Use defa-radio-strip as a tag in html instead, like warmup settings strip does.');
			this.value = option;
		},
	}
};

export const VueRadioStripPlugin = {
	install(Vue, options) {
		Vue.component('defa-radio-strip', VueRadioStripComponent)
	}
};
